import { tenantApi } from './tenantApi';
import type { Customer, CustomerFormData, CustomerFilters, PaginatedCustomers } from '../types/customer.types';

/**
 * Customer API Service
 * Handles all API calls related to customer management
 */
export const customersApi = {
  /** Get all customers with optional filters (paginated) */
  getCustomers: (filters?: CustomerFilters): Promise<PaginatedCustomers> =>
    tenantApi.getPaginated<Customer>('/customers', { params: filters }),

  /** Get a single customer by ID */
  getCustomer: (id: string): Promise<Customer> =>
    tenantApi.getOne<Customer>(`/customers/${id}`, {
      params: { with_deleted: true },
    }),

  /** Create a new customer */
  createCustomer: (customerData: CustomerFormData): Promise<Customer> =>
    tenantApi.postOne<Customer>('/customers', customerData),

  /** Update an existing customer */
  updateCustomer: (id: string, customerData: Partial<CustomerFormData>): Promise<Customer> =>
    tenantApi.putOne<Customer>(`/customers/${id}`, customerData),

  /** Delete a customer */
  deleteCustomer: (id: string): Promise<void> => {
    tenantApi.deleteOne(`/customers/${id}`);
    return Promise.resolve();
  },

  /** Restore a soft-deleted customer */
  restoreCustomer: (id: string): Promise<Customer> =>
    tenantApi.postOne<Customer>(`/customers/${id}/restore`),

  /** Search customers by query (paginated) */
  searchCustomers: (query: string, perPage = 15): Promise<PaginatedCustomers> =>
    tenantApi.getPaginated<Customer>('/customers/search', {
      params: { q: query, per_page: perPage },
    }),
};
